module.exports = __webpack_public_path__ + "img/养老院.aa2ff71a.png";